import React, { useEffect, useState } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane, Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux'
import useDynamicRefs from 'use-dynamic-refs';
import {
    SwitchTransition,
    CSSTransition
} from 'react-transition-group'
import $ from 'jquery'


import { appendModel, modifyModelAttr, orgChange, regChange, siteChange } from '../../../features/site/siteSlice'
import { setStatus } from '../../../features/session/sessionSlice'

import setting from '../../utils/Settings'
import SpinnerLoader from '../Layout/Loaders/SpinnerLoader'

import BrandModification from './SiteTypes/BrandModification'
import RegionModification from './SiteTypes/RegionModification'
import SiteModification from './SiteTypes/SiteModification'
import SalesTokenModification from './SiteTypes/SalesTokenModification';
import history from '../../../history'
import { allowedSiteTypes, serviceMap } from '../../utils/common'
import BreadcrumbHeader from '../Layout/Breadcrumb/BreadcrumbHeader';
import OrganizationModification from './SiteTypes/OrganizationModification';
import { getAgentTokens, getSites } from '../../utils/Sites';

const INITIAL_STATE = {
    selectionType: "ORG",
    autoLoaded: false,
    animationClass: "type-selection",
    serviceType: null,
    siteInView: false,
    componentMap: {
        TOP_ORG: {
            title: "Organization",
            component: OrganizationModification
        },
        ORG: {
            title: setting.topLevelName,
            component: BrandModification
        },
        REG: {
            title: "Region",
            component: RegionModification
        },
        SITE: {
            title: "Site",
            component: SiteModification
        },
        TOKEN: {
            title: "Sales Token",
            component: SalesTokenModification
        }
    },
    chosenView: {title:"", component: BrandModification}
}

const lastTypeMap = {
    "ORG": null,
    "REG": {
        name: setting.topLevelNamePlural,
        type: "ORG"
    },
    "SITE": {
        name: "Regions",
        type: "REG"
    }
}

function TypeSelectionTable(props){
    const dispatch = useDispatch()
    const { selectionType, onRowClick, items, activeIndex } = props
    const { topLevelName, topLevelNamePlural } = setting

    const [filterText, setFilterText] = useState("")
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false)

    const [getRef, setRef] = useDynamicRefs()

    const session = useSelector(state => state.session)

    const siteStatus = useSelector(state => state.site.status)
    const model = useSelector(state => state.site.model)
    const isAdmin = useSelector(state => state.session.isAdmin)
    const resellerToken = useSelector(state => state.site.resellerToken)

    const org = filterText.length > 0 && model?.orgActiveIdx >= 0 ? model.organizationsFilter.find(o => o.siteId === model?.organizations[model?.orgActiveIdx].siteId) : model?.organizations ? model?.organizations[model?.orgActiveIdx] : {}
    const reg = model?.regions ? model?.regions[model?.regActiveIdx] : {}
    const ste = model?.sites ? model?.sites[model?.siteActiveIdx] : {}
    const token = model?.salesTokens ? model?.salesTokens[model?.tokenActiveIdx] : {}

    const headerColumns = {
        "TOKEN": [`Name`, "Sales Token", ""],
        "ORG": [`${topLevelName} Name`, `Sales Token`, ""],
        "REG": ["Region Name", ""],
        "SITE": ["Site Name", "URL", "Claimed Services", ""]
    }

    const typeMap = {
        "TOKEN": "Sales Tokens",
        "ORG": topLevelNamePlural,
        "REG": "Regions",
        "SITE": "Sites"
    }

    const defaultSiteTypeMap = {
        "TOP_ORG": {
            name: '', 
            attr: {
                phone: '', 
                address: '',
                city: '', 
                state: 'AL', 
                zip: ''
            },
            type: 'TOP_ORG'
        },
        "ORG": {
            name: '', 
            attr: {
                phone: '', 
                address: '',
                city: '', 
                state: 'AL', 
                zip: '', 
                token: resellerToken || "ISL"
            },
            type: 'ORG'
        },
        "REG": {
            name: "",
            attr: {},
            type: "REG"
        },
        "SITE": { 
            name: '', 
            attr: {
                url: '', 
                tz: 'Pacific', 
                accounts: {}, roi: {}
            }, 
            type: 'SITE'
        },
        "TOKEN": {
            name: '',
            attr: {
              isAffiliate: true
            },
            type: 'TOKEN',
        }
    }

    const newSite = async(siteType, quickStats=false) => {
        if(quickStats){
            props.onNewSite({
                ...defaultSiteTypeMap[siteType],
                attr: {
                    ...defaultSiteTypeMap[siteType].attr,
                    status: "evaluation",
                    quickStatsSetup: true,
                    expediteOnboarding: true
                }
            })
        } else {
            props.onNewSite(defaultSiteTypeMap[siteType])
        }
        dispatch(appendModel({
            [`${siteType === "TOP_ORG" ? "org" :siteType.toLowerCase()}ActiveIdx`]: -1
        }))
    }

    const BodyColumns = ({site, onRowClick}) => {

        return site.type === "TOKEN" ? <>
            <td>{ site.name }</td>
            <td>{ site?.siteId ?? "ISL" }</td>
            <td align="right" width="5%">
                <button className={`editBtn btn btn-sm ${token?.siteId === site.siteId ? "btn-info": "btn-outline-info"}`}>
                    <i className="editBtn far fa-edit fa-lg"></i>
                </button>
            </td>
        </> :site.type === "ORG" || site.type === "TOP_ORG" ? <>
            <td>{ site.name }</td>
            <td>{ site?.attr?.token ?? "ISL" }</td>
            <td align="right" width="5%">
                {(!model.orgFixed || allowedSiteTypes.includes(model.userSite?.type)) && <button className={`editBtn btn btn-sm ${org?.siteId === site.siteId ? "btn-info": "btn-outline-info"}`}>
                    <i className="editBtn far fa-edit fa-lg"></i>
                </button>}
                {/*<button className="btn btn-sm btn-info" onClick={() => deleteSite(topOrg.siteId)}><i className="far fa-trash-alt fa-lg"></i></button> */}
            </td>
        </> : site.type === "REG" ? <>
            <td>{ site.name }</td>
            <td align="right" width="5%">
                {(!model.orgFixed || allowedSiteTypes.includes(model.userSite?.type) || session.user?.siteId === site.siteId) && <button className={`editBtn btn btn-sm ${reg?.siteId === site.siteId ? "btn-info": "btn-outline-info"}`}>
                    <i className="editBtn far fa-edit fa-lg"></i>
                </button>}
            </td>
        </> : <>
            <td>{ site.name }</td>
            <td>{ site?.attr?.url }</td>
            <td>
                {site?.attr?.accounts ? Object.keys(site?.attr?.accounts).map(key => serviceMap[key] && <img className="mr-1" src={serviceMap[key].img} style={{width:"24px", height: "24px"}} /> ) : "None"}
            </td>
            <td align="right" width="5%">
                {(model?.regions[model.regActiveIdx] && (!Array.isArray(model.regions[model.regActiveIdx].linkedSites) || !model.regions[model.regActiveIdx].linkedSites?.includes(site.siteId))) && <button className={`editBtn btn btn-sm ${ste?.siteId === site.siteId ? "btn-info": "btn-outline-info"}`}>
                    <i className="editBtn far fa-edit fa-lg"></i>
                </button>}
            </td>
        </>
    }

    const onFilterChange = (e) => {
        const { organizations, sites } = model
        let items = [...organizations]
        let itemType = "organizations"

        if(selectionType === "SITE"){
            items = [...sites]
            itemType = "sites"
        }

        if(e.target.value.length >= 3){
            dispatch(modifyModelAttr({
                key:`${itemType}Filter`,
                body: [...items.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase()))]
            }))
        } else {
            dispatch(modifyModelAttr({
                key: `${itemType}Filter`,
                body: [...items]
            }))
        }
        setFilterText(e.target.value)
    }

    useEffect(() => {
        const siteLevel = (selectionType === "ORG" || selectionType === "TOP_ORG") ? org : 
            selectionType === "REG" ? reg : selectionType === "TOKEN" ? token : ste

        const elRef = getRef(siteLevel?.siteId)

        if(selectionType !== "SITE"){
            setFilterText("")
        }

        if(selectionType === "TOKEN"){
            getAgentTokens()
            .then((tokenResp) => {
                const {response, error} = tokenResp
                let salesTokens = []
                if(response && response.salesTokens){
                    salesTokens = response.salesTokens
                        .sort((a, b) => a.name !== null && b.name !== null && a.name.toUpperCase()>b.name.toUpperCase() ? 1 : a.name===b.name ? 0 : -1)
                }
                
                dispatch(appendModel({
                    salesTokens
                }))
            })
        }

        elRef?.current?.scrollIntoView(
            { behavior: 'auto', block: 'center' }
        );

        $('.affixed').affix({
            offset:{
                top: 50
            }
        });

    }, [selectionType])

    useEffect(() => {
        if(model.resetFilteredText){
            setFilterText("")
            dispatch(appendModel({
                resetFilteredText: false
            }))
        }
    }, [model.resetFilteredText])

    return <>

        <div class="card card-raised h-100 overflow-hidden affixed rounded-0 mb-0">
            <div class="card-header bg-primary text-white px-4"><div class="fw-500">{typeMap[selectionType]}</div></div>
            <div class="card-body p-0">
                <div className="d-lg-flex d-xl-flex d-md-none d-sm-none d-none justify-content-between align-items-center p-20">
                    {(selectionType !== "SITE" && lastTypeMap[selectionType]) ? 
                        (selectionType !== "REG" || model?.reseller || isAdmin || (selectionType === "REG" && allowedSiteTypes.includes(model?.userSite?.type))) ? 
                        <div className="btn btn-group">
                            <button className="btn btn-primary btn-lg" onClick={() => onRowClick(null, null, lastTypeMap[selectionType].type, "type-selection-r")}>
                                <i class="fas fa-chevron-circle-left"></i> Back to {lastTypeMap[selectionType].name}
                            </button>
                        </div> : 
                        <></> : 
                    <></>}

                    {(selectionType === "TOKEN" && isAdmin) && <button className="btn btn-lg btn-outline-primary" onClick={() => newSite("TOKEN")}>
                        <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                    </button>}

                    {["ORG", "TOP_ORG"].includes(selectionType) && !model.orgFixed && <>
                        {isAdmin && <input id="filterOrg" className="form-control input-lg" onChange={onFilterChange} placeholder="Filter" value={filterText} style={{width: "200px"}} />}
                        {isAdmin ? <ButtonDropdown direction="left" isOpen={isCompanyDropdownOpen} toggle={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                            <DropdownToggle caret color="primary" style={{fontSize: "14px"}} />
                            <Button id="caret" color="primary" outline size="lg" onClick={() => newSite("ORG")}>
                                <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                            </Button>
                            <DropdownMenu>
                                <DropdownItem onClick={() => newSite("TOP_ORG")}>Add Organization</DropdownItem>
                            </DropdownMenu>
                        </ButtonDropdown> : (!model.reseller || (model.reseller && !model.isAffiliate)) ? <button className="btn btn-lg btn-outline-primary" onClick={() => newSite("ORG")}>
                            <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                        </button> : <></>}
                    </>}

                    {selectionType === "REG" && (!model.reseller || (model.reseller && !model.isAffiliate)) && (!model.orgFixed || allowedSiteTypes.includes(model.userSite?.type)) && <button className="btn btn-lg btn-outline-primary" onClick={() => newSite("REG")}>
                        <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                    </button>}

                    {selectionType === "SITE" && (!model.reseller || (model.reseller && !model.isAffiliate)) && !model.singleSiteUser && model?.regions[model?.regActiveIdx] && !model?.regions[model?.regActiveIdx].linkedSites && <>
                        {(isAdmin || (model.orgFixed && model.userSite?.type === "ORG")) && <input id="filterSite" className="form-control input-lg" onChange={onFilterChange} placeholder="Filter" value={filterText} style={{width: "200px"}} />}
                        <>
                            {(model?.reseller || isAdmin) && <button className="btn btn-lg btn-primary" onClick={() => newSite("SITE", true)}>
                                <i class="far fa-plus-square"></i> Add Initial Scan Site
                            </button>}
                            <button className="btn btn-lg btn-outline-primary" onClick={() => newSite("SITE")}>
                                <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                            </button>
                        </>
                    </>}
                </div>
                <div className="d-lg-none d-xl-none d-md-flex d-sm-flex d-flex justify-content-between align-items-center p-10">
                    {selectionType !== "SITE" && lastTypeMap[selectionType] ? (selectionType !== "REG" || model?.reseller || isAdmin || (selectionType === "REG" && allowedSiteTypes.includes(model?.userSite?.type))) ? <div className="btn btn-group">
                        <button className="btn btn-primary" onClick={() => onRowClick(null, null, lastTypeMap[selectionType].type, "type-selection-r")}>
                            <i class="fas fa-chevron-circle-left"></i> Back to {lastTypeMap[selectionType].name}
                        </button>
                    </div> : <></> : <div></div>}

                    {["ORG", "TOP_ORG"].includes(selectionType) && !model.orgFixed && <>
                        {isAdmin && <input className="form-control" id="filterOrg" onChange={onFilterChange} placeholder="Filter" value={filterText} style={{width: "200px"}} />}
                        <button className="btn btn-outline-primary" onClick={() => newSite("ORG")}>
                            <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                        </button>
                    </>}

                    {selectionType === "REG" && (!model.reseller || (model.reseller && !model.isAffiliate)) && (!model.orgFixed || allowedSiteTypes.includes(model.userSite?.type)) && <button className="btn btn-outline-primary" onClick={() => newSite("REG")}>
                        <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                    </button>}

                    {selectionType === "SITE" && (!model.reseller || (model.reseller && !model.isAffiliate)) && !model.singleSiteUser && <>
                        {(model?.reseller || isAdmin) && <button className="btn btn-primary" onClick={() => newSite("SITE", true)}>
                            <i class="far fa-plus-square"></i> Add Initial Scan Site
                        </button>}
                        <button className="btn btn-outline-primary" onClick={() => newSite("SITE")}>
                            <i class="far fa-plus-square"></i> Add {typeMap[selectionType]}
                        </button>
                    </>}
                </div>
            </div>
        </div>
        <div class="card card-raised h-100 overflow-hidden rounded-0">
            <div class="card-body p-0">
                {siteStatus === "loading" ? <SpinnerLoader /> : <div className="table-responsive">
                    <table className="table table-hover" id={`${selectionType.toLowerCase()}Tbl`}>
                        <tbody class="align-middle"></tbody>
                        <thead class="text-xs font-monospace">
                            <tr>
                                {headerColumns[selectionType].map(col => <th class="border-bottom-0 text-muted">{col}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {items && items.map((site, index) => (
                            <tr ref={setRef(site.siteId)} className={`${selectionType === "SITE" && ste?.siteId === site.siteId ? "active" : ""}
                                    ${selectionType === "REG" && reg?.siteId === site.siteId ? "active" : ""}
                                    ${selectionType === "ORG" && org?.siteId === site.siteId ? "active" : ""} 
                                    ${selectionType === "TOKEN" && token?.siteId === site.siteId ? "active" : ""} hover`} 
                                onClick={(e) => onRowClick(e, index) } 
                                key={index} data-siteid={site.siteId}>
                                <BodyColumns site={site} />
                            </tr>
                            )) }
                            {/* {model.topOrgActiveIdx > -1 && <tr>
                                <td colSpan="6">
                                    <a href onClick={() =>addRegion()} data-target="#modal-reg" data-toggle="modal"><i className="fas fa-plus-circle fa-2x"></i></a>
                                </td>
                            </tr>} */}
                        </tbody>
                    </table>
                </div>}            
            </div>
        </div>
    </>
}

function SiteManagement(props){
    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const model = useSelector(state => state.site.model)
    const token = useSelector(state => state.session.token)
    const isAdmin = useSelector(state => state.session.isAdmin)

    const loadSiteService = async(siteId, serviceType) => {
        const site = model.all.find(x => x.type==='SITE' && x.siteId === siteId)
        if (!site) {
            return
        }

        await dispatch(orgChange(model.organizations.findIndex(org => site.sitePath.includes(org.siteId))))
        
        await setState(prev => ({
            ...prev,
            selectionType: "REG",
            site,
            autoLoaded: true
        }))
        
        await viewSite(site, serviceType)
    }
    
    useEffect(() => {
        $('.affixed').affix({
            offset:{
                top: 50
            }
        });
        
        if(props?.match?.params){
            const { siteId, type } = props.match.params
            loadSiteService(siteId, type)
        } else {
            if(model.orgFixed){
                if(model.userSite?.type === "ORG"){
                    if(model?.siteActiveIdx > -1){                        
                        dispatch(orgChange(0))
                        .then(() => setState(prev => ({
                            ...prev,
                            selectionType: "REG"
                        })))
                        .then(() => viewSite(model.regions[model.regions.findIndex(r => r.siteId === model.userSite?.siteId)]))

                    } else {

                        dispatch(orgChange(0))
                        .then(() => setState(prev => ({
                            ...prev,
                            selectionType: "ORG"
                        })))
                        .then(() => viewSite(model.organizations[0]))
                    }
                } else if(model.userSite?.type === "REG"){
                    dispatch(orgChange(0))
                    // .then(() => {                        
                    //     let index = model.regions.findIndex(r => r.siteId === model.userSite?.siteId)
                    //     return dispatch(regChange( index !== -1  ? index : 0))
                    // })
                    .then(() => setState(prev => ({
                        ...prev,
                        selectionType: "REG"
                    })))
                    .then(() => viewSite(model.regions[model.regions.findIndex(r => r.siteId === model.userSite?.siteId)]))

                } else if(model.userSite?.type === "SITE"){
                    
                    dispatch(orgChange(0))
                    .then(() =>dispatch(regChange(0)))
                    .then(() => dispatch(siteChange(0)))
                    .then(() => setState(prev => ({
                        ...prev,
                        selectionType: "SITE"
                    })))
                    .then(() => model.sites[0] ? viewSite(model.sites[0]) : true)
                }
            }
        }

        return () => {
            dispatch(appendModel({
                sitesFilter: [],
                organizationsFilter: [...model.organizations]
            }))
        }
    }, [])
    
    useEffect(() => {
        if(props?.match?.params && state.autoLoaded){
            const { siteId, type } = props.match.params
            
            const { site } = state
            dispatch(regChange(model.regions.findIndex(reg => site.sitePath.includes(reg.siteId))))
            .then(() => dispatch(siteChange(model.sites.findIndex(s => s.siteId === siteId))))

            setState(prev => ({
                ...prev,
                siteInView: true,
                autoLoaded: false
            }))
        }
    }, [state.autoLoaded, model])

    const viewSite = async(site, serviceType, siteInView=null) => {
        await dispatch(appendModel({
            [`${site?.type === "TOP_ORG" ? "topOrg" : site?.type?.toLowerCase()}Form`]: {
                ...site,
                attr: {
                    ...(site?.type === "SITE" ? 
                    {tz: 'Pacific', city: '', state: '', ...(site?.attr ?? {})} : {
                        ...(site?.attr ?? {})
                    })
                }
            }
        }))

        const st = {
            chosenView: state.componentMap[site?.type],
            serviceType
        }

        if(siteInView !== null){
            st.siteInView = siteInView
        }

        await setState(prev => ({
            ...prev,
            ...st
        }))
    }

    const { chosenView, serviceType, selectionType, siteInView } = state

    const siteViewable = (!model.orgFixed || allowedSiteTypes.includes(model.userSite?.type)) ||
        (model.userSite?.type === "REG" && model?.regions[model.regActiveIdx] && model?.regions[model.regActiveIdx].sitePath?.includes(model.userSite?.siteId)) || 
        (model.userSite?.type === "SITE" && model?.sites[model.siteActiveIdx] && model?.sites[model.siteActiveIdx].sitePath?.includes(model.userSite?.siteId))
    return <>
        {/* <header class="bg-black">
            <div class="container-xl p-5">
                <div class="row align-items-center justify-content-between">
                    <div class="col-12 col-md mb-4 mb-md-0">
                        <h1 class="mb-1 display-4 fw-500 text-white">Site Management</h1>
                    </div>
                </div>                
            </div>
        </header> */}

        <BreadcrumbHeader title="Administration" url="/admin" grouping="admin" />
        <div class={`row p-5 ${(siteInView) ? "d-none d-sm-none d-md-none d-lg-flex" : ""}`}>
            <div class={`col-xl-6 col-lg-6 col-md-12 mb-5 ${(model.userSite?.type === "SITE") ? "d-none" : ""}`}>
                <SwitchTransition mode={"out-in"}>
                    <CSSTransition
                        key={selectionType}
                        addEndListener={(node, done) => {
                            node.addEventListener("transitionend", done, false);
                        }}
                        classNames={state.animationClass}>
                        <div className="type-container">

                            {isAdmin ? <>
                            <Nav className="profile-header-tab" pills fill>
                                <NavItem>
                                    <NavLink
                                        className={selectionType === "ORG" ? "active": ""}
                                        onClick={() => setState(prev => ({...prev, selectionType: "ORG"})) }>
                                        COMPANY / ORG
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={selectionType === "TOKEN" ? "active": ""}
                                        onClick={() => setState(prev => ({...prev, selectionType: "TOKEN"}))}>
                                        SALES TOKENS
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={selectionType} className="mb-5">
                                <TabPane tabId="ORG">
                                    <TypeSelectionTable 
                                        selectionType={selectionType} 
                                        onNewSite={(s) => viewSite(s, null, true)}
                                        items={model?.organizationsFilter} 
                                        activeIndex={model?.orgActiveIdx} 
                                        onRowClick={async(e, idx, overrideType=null, animationClass=null) => {                            
                                            let idxOrg = idx
                                            if(model.organizationsFilter.length < model.organizations.length){
                                                idxOrg = model.organizations.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                            }
                                            if(!e || (e && !e.target.className.includes("editBtn"))){
                                                await setState(prev => ({
                                                    ...prev,
                                                    selectionType: overrideType ? overrideType :"REG",
                                                    animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                                }))
                                            }
                                            if(idxOrg !== null){
                                                const {response, error} = await getSites(token, model.organizationsFilter[idx].siteId)

                                                let organizations = [...model.organizations]
                                                let organizationsFilter = [...model.organizationsFilter]
                                                let all = [...model.all]
                                                
                                                organizationsFilter[idx] = {...response.result}
                                                
                                                let idxOrgList = organizations.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                                organizations[idxOrgList] = {...response.result} 
                                                
                                                let idxOrgAll = all.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                                all[idxOrgAll] = {...response.result} 

                                                await dispatch(appendModel({
                                                    organizationsFilter,
                                                    organizations,
                                                    all
                                                }))
                                                dispatch(orgChange(idxOrg));
                                                dispatch(appendModel({
                                                    orgActiveIdx: idxOrg,
                                                    organizationsFilter: !e || (e && !e.target.className.includes("editBtn")) ? [...organizations] : [...organizationsFilter]
                                                }))
                                                    
                                                viewSite(model.organizations[idxOrg])
                                                if(e && e.target.className.includes("editBtn")){
                                                    setState(prev => ({
                                                        ...prev,
                                                        siteInView: true,
                                                    }))
                                                }
                                            }
                                        }}
                                    />

                                </TabPane>
                                <TabPane tabId="TOKEN">
                                    <TypeSelectionTable 
                                        selectionType={selectionType} 
                                        onNewSite={(s) => viewSite(s, null, true)}
                                        items={model?.salesTokens} 
                                        activeIndex={model?.tokenActiveIdx} 
                                        onRowClick={async(e, idx, overrideType=null, animationClass=null) => {
                                            if(!e || (e && !e.target.className.includes("editBtn"))){
                                                await setState(prev => ({
                                                    ...prev,
                                                    selectionType: "TOKEN",
                                                    animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                                }))
                                            }
                                            if(idx !== null){
                                                const {response, error} = await getSites(token, model.salesTokens[idx].siteId)

                                                let salesTokens = [...model.salesTokens]                                                
                                                salesTokens[idx] = {...response.result}
                                            

                                                await dispatch(appendModel({
                                                    salesTokens
                                                }))
                                                dispatch(appendModel({
                                                    tokenActiveIdx: idx,
                                                }))
                                                    
                                                viewSite(model.salesTokens[idx])
                                                if(e && e.target.className.includes("editBtn")){
                                                    setState(prev => ({
                                                        ...prev,
                                                        siteInView: true,
                                                    }))
                                                }
                                            }
                                        }}
                                    />

                                </TabPane>
                                </TabContent>
                            </> : <>
                                {selectionType === "ORG" && <TypeSelectionTable 
                                    selectionType={selectionType} 
                                    onNewSite={(s) => viewSite(s, null, true)}
                                    items={model?.organizationsFilter} 
                                    activeIndex={model?.orgActiveIdx} 
                                    onRowClick={async(e, idx, overrideType=null, animationClass=null) => {                            
                                        let idxOrg = idx
                                        if(model.organizationsFilter.length < model.organizations.length){
                                            idxOrg = model.organizations.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                        }
                                        if(!e || (e && !e.target.className.includes("editBtn"))){
                                            await setState(prev => ({
                                                ...prev,
                                                selectionType: overrideType ? overrideType :"REG",
                                                animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                            }))
                                        }
                                        if(idxOrg !== null){
                                            const {response, error} = await getSites(token, model.organizationsFilter[idx].siteId)

                                            let organizations = [...model.organizations]
                                            let organizationsFilter = [...model.organizationsFilter]
                                            let all = [...model.all]
                                            
                                            organizationsFilter[idx] = {...response.result}
                                            
                                            let idxOrgList = organizations.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                            organizations[idxOrgList] = {...response.result} 
                                            
                                            let idxOrgAll = all.findIndex(o => o.siteId === model.organizationsFilter[idx].siteId)
                                            all[idxOrgAll] = {...response.result} 

                                            await dispatch(appendModel({
                                                organizationsFilter,
                                                organizations,
                                                all
                                            }))
                                            dispatch(orgChange(idxOrg));
                                            dispatch(appendModel({
                                                orgActiveIdx: idxOrg,
                                                organizationsFilter: !e || (e && !e.target.className.includes("editBtn")) ? [...organizations] : [...organizationsFilter]
                                            }))
                                                
                                            viewSite(model.organizations[idxOrg])
                                            if(e && e.target.className.includes("editBtn")){
                                                setState(prev => ({
                                                    ...prev,
                                                    siteInView: true,
                                                }))
                                            }
                                        }
                                    }}
                                />}
                                </>}
                            {selectionType === "REG" && <>
                            {/* <div className="card affixed">
                                <h2>{model.organizations?.length > 0 && model?.orgActiveIdx >= 0 ? model.organizations[model.orgActiveIdx].name : ""}</h2>
                            </div> */}
                            <TypeSelectionTable 
                                selectionType={selectionType} 
                                onNewSite={(s) => viewSite(s, null, true)}
                                items={model?.regions} 
                                activeIndex={model?.regActiveIdx} 
                                onRowClick={async(e, idx, overrideType=null, animationClass=null) => {
                                    await dispatch(appendModel({
                                        resetFilteredText: true
                                    }))
                                    if(!e || (e && !e.target.className.includes("editBtn"))){
                                        await setState(prev => ({
                                            ...prev,
                                            selectionType: overrideType ? overrideType :"REG",
                                            animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                        }))
                                    }
                                    if(idx !== null){
                                        const {response, error} = await getSites(token, model.regions[idx].siteId)

                                        let all = [...model.all]
                                        let regions = [...model.regions]
                                        
                                        regions[idx] = {...response.result} 
                                        
                                        let idxAll = all.findIndex(s => s.siteId === model.regions[idx].siteId)
                                        all[idxAll] = {...response.result} 

                                        await dispatch(regChange(idx));
                                        dispatch(appendModel({
                                            regions,
                                            all,
                                            regActiveIdx: idx,
                                            siteActiveIdx: model?.siteActiveIdx
                                        }))
                                        viewSite(regions[idx])
                                        if(e && e.target.className.includes("editBtn")){
                                            setState(prev => ({
                                                ...prev,
                                                siteInView: true,
                                            }))
                                        }
                                    }
                                }}
                            />
                            <TypeSelectionTable 
                                selectionType={"SITE"} 
                                onNewSite={(s) => viewSite(s, null, true)}
                                items={model?.sitesFilter} 
                                activeIndex={model?.siteActiveIdx} 
                                onRowClick={async(e, idx, overrideType=null, animationClass=null) => {
                                    const region = model.regions[model?.regActiveIdx]
                                    const site = model.sites[model?.siteActiveIdx]

                                    let idxSite = idx
                                    if(model.sitesFilter.length < model.sites.length){
                                        idxSite = model.sites.findIndex(s => s.siteId === model.sitesFilter[idx].siteId)
                                    }
                                    if(!e || (e && !e.target.className.includes("editBtn"))){
                                        await setState(prev => ({
                                            ...prev,
                                            selectionType: overrideType ? overrideType :"REG",
                                            animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                        }))
                                    }
                                    if(!region?.linkedSites?.includes(site.siteId)){
                                        if(idxSite !== null){
                                            const {response, error} = await getSites(token, model.sitesFilter[idx].siteId)

                                            let sites = [...model.sites]
                                            let sitesFilter = [...model.sitesFilter]
                                            let all = [...model.all]
                                            
                                            sitesFilter[idx] = {...response.result}
                                            
                                            let idxSiteList = sites.findIndex(o => o.siteId === model.sitesFilter[idx].siteId)
                                            sites[idxSiteList] = {...response.result} 
                                            
                                            let idxSiteAll = all.findIndex(o => o.siteId === model.sitesFilter[idx].siteId)
                                            all[idxSiteAll] = {...response.result} 

                                            await dispatch(appendModel({
                                                sitesFilter,
                                                sites,
                                                all
                                            }))

                                            await dispatch(siteChange(idxSite));
                                            dispatch(appendModel({
                                                siteActiveIdx: idxSite ?? model?.siteActiveIdx
                                            }))
                                            viewSite(sites[idxSite])
                                            setState(prev => ({
                                                ...prev,
                                                siteInView: true,
                                            }))
                                        }
                                    }
                                }}
                            />
                            </>}
                            {/* {selectionType === "SITE" && <TypeSelectionTable 
                                selectionType={selectionType} 
                                onNewSite={(s) => viewSite(s, null, true)}
                                items={model?.sites} 
                                activeIndex={model?.siteActiveIdx} 
                                onRowClick={async(e, idx, overrideType=null, animationClass=null) => {
                                    const region = model.regions[model?.regActiveIdx]
                                    const site = model.sites[model?.siteActiveIdx]

                                    if(!e || (e && !e.target.className.includes("editBtn"))){
                                        await setState(prev => ({
                                            ...prev,
                                            selectionType: overrideType ? overrideType :"SITE",
                                            animationClass: animationClass ? animationClass : INITIAL_STATE.animationClass
                                        }))
                                        await dispatch(siteChange(idx));
                                    }
                                    if(!region?.linkedSites?.includes(site.siteId)){
                                        if(idx !== null){
                                            dispatch(appendModel({
                                                siteActiveIdx: idx ?? model?.siteActiveIdx
                                            }))
                                            viewSite(model.sites[idx])
                                            setState(prev => ({
                                                ...prev,
                                                siteInView: true,
                                            }))
                                        }
                                    }
                                }}
                            />} */}
                        </div>
                    </CSSTransition>
                </SwitchTransition>
            </div>
            <div class="col-xl-6 col-lg-6 mb-5 d-none d-sm-none d-md-none d-lg-block">
                <div className="affixed" style={{zIndex: "1005"}}>
                    {chosenView && chosenView !== INITIAL_STATE.chosenView && siteViewable && <chosenView.component 
                        title={chosenView.title} serviceType={serviceType} 
                        onDeleteSite={(siteId, type) => setState(prev => ({
                            ...prev,
                            chosenView: INITIAL_STATE.chosenView
                        }))}
                    />}
                </div>
            </div>
        </div>
        {siteInView && <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
            {chosenView && chosenView !== INITIAL_STATE.chosenView && siteViewable && <chosenView.component 
                title={chosenView.title} 
                serviceType={serviceType} 
                onGoBack={() => setState(prev => ({
                    ...prev,
                    siteInView: false,
                    animationClass: INITIAL_STATE.animationClass,
                    selectionType: prev.selectionType
                }))}
                onDeleteSite={(siteId, type) => setState(prev => ({
                    ...prev,
                    chosenView: INITIAL_STATE.chosenView
                }))}
            />}
        </div>}
    </>
}

export default SiteManagement